import React from 'react';
import Img3 from 'components/img3';
import './FrontGrid.css';
var MyGrid = function () {
    return (React.createElement("div", { className: 'Gcover' },
        React.createElement("div", { className: 'box' },
            React.createElement(Img3, { height: '100%', borderRadius: '0px', model: 'https://lh6.googleusercontent.com/NaRQNRqsIvfrrg6SpjH0Uj4_U1NPRxBz_dWUNU31ALdeyQP_nRbnixmtVv4ifNROnJtvy31ABBHvf58_MVArw5J_8RISxkgzTi0cArEtgP4FUF1vabOJqaeGQwCS8H21ErghtfEdWSY' }, " ")),
        React.createElement("div", { className: 'box' },
            React.createElement(Img3, { height: '100%', borderRadius: '0px', model: 'https://lh6.googleusercontent.com/5Eb_wcIogmQMdgIGtxyWaGfJxiY_GbeSuwtOA8sHQhHMu5ygfPuxd1nW-3bQyRWjWDby6yVSOjTlsL5q3_owrqLe4yKpzcVLgs1pteAu' }, " ")),
        React.createElement("div", { className: 'box' },
            React.createElement(Img3, { MaxWidth: '100%', backgroundColor: 'grey', 
                // height={'300px'} 
                borderRadius: '0px', ArFile: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/FaceMask2.usdz?alt=media&token=6ce6e94b-b527-4b86-b49c-c13ca88ba330', model: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/MASKrose.glb?alt=media&token=f8daa2fd-8a00-45f8-90f2-3d2ffadca3b9' })),
        React.createElement("div", { className: 'box' },
            React.createElement(Img3, { height: '100%', borderRadius: '0px', model: 'https://scontent-lga3-2.cdninstagram.com/v/t51.2885-15/sh0.08/e35/p640x640/104168368_170921237799979_5127674296596309505_n.jpg?_nc_ht=scontent-lga3-2.cdninstagram.com&_nc_cat=107&_nc_ohc=AVz49nB_p7kAX9bM61I&oh=379aabf6f9e6ade1688ccc57391213d5&oe=5F3659A5' }, " "))));
};
export default MyGrid;



//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/ImageCarousel/PublicDisplay/Grid/Grid.tsx
// module id = 1546
// module chunks = 0 1 2 3